<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row no-gutters justify="start">
          <v-btn
            small
            @click="beforeRoute"
            color="primary"
            outlined
            class="rounded text-capitalize mt-n5 ml-15"
            ><v-icon>keyboard_backspace</v-icon> Volver</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!is_order && hasFeature('SHOP-052')"
            small
            @click="openAddSupplier"
            color="primary"
            outlined
            class="rounded text-capitalize mt-n5 ml-15"
            ><v-icon small>mdi-account-plus</v-icon> Agregar suplidor</v-btn
          >
          <v-btn
            v-if="!is_order && hasFeature('SHOP-052')"
            small
            @click="dialogConfirm=true"
            color="error"
            outlined
            class="rounded text-capitalize mt-n5 ml-15"
            ><v-icon small>cancel</v-icon> Cancelar</v-btn
          >
        </v-row>
        <v-row justify="center" class="mt-n2">
          <QuotesGroupsVue :key="refreshKey" :quote="id_group" />
        </v-row>
      </v-col>
    </v-row>
    <DialogConfirm
      :showDialog="dialogConfirm"
      :loading="loading_cancel"
      :confirm_settings="{
        title: 'Seguro que desea cancelar este grupo de cotización?',
        btn_affirmative: 'No, volver',
        btn_negative: 'Si, cancelar',
        icon: 'mdi-alert-circle',
        size: '45%',
      }"
      @closeDialog="cancelGroup"></DialogConfirm>

    <v-dialog v-model="dialogAddSupplier" max-width="520" persistent>
      <v-card>
        <v-card-title class="py-4 px-6">
          <v-icon left color="primary">mdi-account-plus</v-icon>
          <span class="font-weight-bold">Agregar suplidor al grupo</span>
        </v-card-title>
        <v-card-subtitle class="px-6 pt-1">
          Se crearán los mismos artículos y cantidades del grupo para el nuevo suplidor, sin precio.
        </v-card-subtitle>
        <v-card-text class="px-6">
          <v-autocomplete
            v-model="newSupplier"
            :items="suppliers"
            :loading="loadingSuppliers"
            :search-input.sync="searchSupplier"
            item-text="name"
            item-value="entity_id"
            return-object
            no-filter
            label="Suplidor"
            placeholder="Escribe para buscar..."
            no-data-text="No hay suplidores"
            outlined
            dense
            clearable
            @change="onSupplierChange"
          ></v-autocomplete>
          <v-select
            v-model="newCurrency"
            :items="currencies"
            :item-text="(c) => `${c.code} - ${c.description}`"
            item-value="id"
            label="Moneda"
            outlined
            dense
          ></v-select>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn text :disabled="loadingAdd" @click="dialogAddSupplier = false">Cancelar</v-btn>
          <v-btn color="success" depressed :loading="loadingAdd" @click="addSupplier">
            <v-icon left size="18">mdi-content-save</v-icon>
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import QuotesGroupsVue from "@/components/Shop/QuotesGroups.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
export default {
  components: { QuotesGroupsVue, DialogConfirm },
  data: () => ({
    id_group: null,
    dialogConfirm: false,
    loading_cancel: false,
    is_order: false,
    refreshKey: 0,
    dialogAddSupplier: false,
    loadingAdd: false,
    loadingSuppliers: false,
    suppliers: [],
    searchSupplier: null,
    searchTimeout: null,
    newSupplier: null,
    newCurrency: null,
    currencies: [],
  }),

  watch: {
    searchSupplier(val) {
      if (this.newSupplier && val === this.newSupplier.name) return;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.loadSuppliers(val), 400);
    },
  },

  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.id_group = this.$route.params.id;
      this.is_order = this.$route.params.is_order;
    },
    async openAddSupplier() {
      this.newSupplier = null;
      this.newCurrency = null;
      this.dialogAddSupplier = true;
      if (this.currencies.length === 0) {
        try {
          const resultCurrencies = await this.api_Get("accounting/currencies");
          this.currencies = await resultCurrencies.json();
        } catch (error) {
          this.$toast.error("Error al cargar monedas: " + error);
        }
      }
      if (this.suppliers.length === 0) this.loadSuppliers("");
    },
    async loadSuppliers(search) {
      this.loadingSuppliers = true;
      try {
        let url = `accounting/entity_suppliers_paginated?page=1&limit=50`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        const result = await this.api_Get(url);
        const response = await result.json();
        this.suppliers = response.data || [];
      } catch (error) {
        this.$toast.error("Error al cargar suplidores: " + error);
        this.suppliers = [];
      }
      this.loadingSuppliers = false;
    },
    onSupplierChange(supplier) {
      if (supplier && supplier.currency_id && this.newCurrency == null) {
        this.newCurrency = supplier.currency_id;
      }
    },
    async addSupplier() {
      if (!this.newSupplier) {
        this.$toast.warning("Debe seleccionar un suplidor");
        return;
      }
      if (this.newCurrency == null) {
        this.$toast.warning("Debe seleccionar la moneda");
        return;
      }
      this.loadingAdd = true;
      try {
        const request = await this.api_Post("shopping/add_supplier_quote_group", {
          quote_id: parseInt(this.id_group),
          supplier_id: this.newSupplier.entity_id,
          currency_id: this.newCurrency,
          user_id: this.$store.state.auth.user.user.user_id,
        });
        const data = await request.json();
        if (request.status !== 200) {
          this.$toast.error(data.message || data.detail || "Error al agregar el suplidor");
        } else {
          this.$toast.success("Suplidor agregado al grupo de cotización");
          this.dialogAddSupplier = false;
          this.refreshKey++;
        }
      } catch (error) {
        this.$toast.error(error.message);
      }
      this.loadingAdd = false;
    },
    async cancelGroup(response) {
      if(response){
        this.dialogConfirm = false;
        return
      };
      this.loading_cancel = true;
      try {
        const response = await this.api_Post(`/shopping/cancel_quote_group`,{
          id: parseInt(this.id_group),
        });
        if (response.status !== 200) {
          this.$toast.error("Error al cancelar el grupo de cotización");
          this.loading_cancel = false;
          return;
        }
        this.$toast.success("Grupo de cotización cancelado correctamente");
        this.beforeRoute();
      } catch (error) {
        this.$toast.error(error.message);
        console.error(error.message);
      }
      this.dialogConfirm = false;
      this.loading_cancel = false;
    }
  },
};
</script>

<style></style>
